import { useEffect } from 'react'
import { observer } from 'mobx-react'

import { UnauthorisedLayout } from '../layouts'
import type { PublicRouteProps } from './Router.types'

export const PublicRoute = observer((props: PublicRouteProps) => {
  const { component: Component, onRender } = props

  useEffect(() => {
    if (onRender) {
      onRender()
    }
  }, [onRender])

  const Layout = (
    <UnauthorisedLayout>
      <Component />
    </UnauthorisedLayout>
  )

  return Layout
})
